import { getPdfSimpliBaseURL } from "@/Services/base-url/api-constants";
import { deleteCookie, getLinkWithLocale, readCookie } from "@/utils/helper";

export function redirectToPaymentPlansPage(locale = ""): void {
  if (readCookie("sast")) {
    deleteCookie("sast");
  }

  const localeVal = locale ?? "";
  const urlPost = `${getPdfSimpliBaseURL}/app`;
  const redirectPath = getLinkWithLocale(localeVal, "billing/plans");
  window.location.assign(urlPost + redirectPath);
}
